import { render, staticRenderFns } from "./DetailStays.vue?vue&type=template&id=d186aff2&lang=html"
import script from "./DetailStays.vue?vue&type=script&lang=js"
export * from "./DetailStays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports